export const seguimientoStatuses = [
  ["Ganado", "Ganado"],
  ["Pre-Entrevista", "Pre-entr."],
  ["Post-Entrevista", "Post-entr."],
  ["Post-Venta", "Post-venta"],
  ["En Reactivación", "En reactivación"],
  ["Reactivado", "Reactivado"],
  ["Perdido", "Perdido"],
];
const localDay = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
export function seguimientoFilters(
  { schedule = "", statuses = [], interviews = false },
  now = new Date(),
) {
  const filters = [];
  const add = (property, operator, value) =>
    filters.push({ property, operator, value, condition: "AND" });
  const today = localDay(now);
  if (schedule === "vigentes") add("fecha_vencimiento", ">=", today);
  if (schedule === "porVencer") {
    const future = new Date(now);
    future.setDate(future.getDate() + 2);
    add("fecha_vencimiento", ">", today);
    add("fecha_vencimiento", "<=", localDay(future));
  }
  if (schedule === "vencidos") add("fecha_vencimiento", "<", today);
  if (interviews) {
    filters.push({
      relation: "seguimientoRealizado",
      property: "catg_seguimiento",
      operator: "=",
      value: "ENTREVISTAS",
      condition: "AND",
    });
  }
  const validStatuses = statuses.filter((s) =>
    seguimientoStatuses.some(([value]) => value === s),
  );
  if (validStatuses.length)
    filters.push({
      condition: "AND",
      group: validStatuses.map((value) => ({
        property: "estatus",
        operator: "=",
        value,
        condition: "OR",
      })),
    });
  else {
    add("estatus", "!=", "Ganado");
    add("estatus", "!=", "Perdido");
  }
  // Sencha muestra únicamente el último registro de cada cadena, aun con estatus explícitos.
  add("id_seguimiento_posterior", "=", 0);
  return filters;
}

// One OR group stays inside the other filters (AND), including date/status filters.
export function seguimientoSearch(search = "") {
  const value = search.trim();
  if (!value) return [];
  return [{ condition: "AND", group: [
    { property: "notas_seguimiento", operator: "LIKE", value, condition: "OR" },
    ...["clave", "nombre", "rfc", "email", "telefono", "telefono2"].map(property => ({
      property, relation: "cliente", operator: "LIKE", value, condition: "OR",
    })),
    ...(/^\d+$/.test(value) ? [{ property: "id", operator: "=", value, condition: "OR" }] : []),
  ] }];
}
export function seguimientoWhatsAppUrl(record) {
  const cliente = record?.cliente || {};
  const phone = [record?.cliente_telefono, cliente.telefono, cliente.telefono2]
    .map(value => String(value || "").replace(/\D/g, ""))
    .find(value => value.length >= 10 && value.length <= 15);
  if (!phone) return null;
  return `https://wa.me/${phone.length === 10 ? "52" : ""}${phone}`;
}
